import CCColors from '@/Utils/CCColors';
import {vs} from '@/Utils/Dimensions';
import {StyleSheet} from 'react-native';

const REVIEW_CENTER_WIDTH = '100%';
const REVIEW_LEFT_PANEL_WIDTH = 324;
const REVIEW_RIGHT_PANEL_WIDTH = 360;
const styles = StyleSheet.create({
  mobileContainer: {
    flex: 1,
    width: '100%',
    alignItems: 'stretch',
    backgroundColor: '#FAF6EB',
  },
  mobileHeader: {
    width: '100%',
    paddingHorizontal: 12,
    paddingTop: 8,
    paddingBottom: 6,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
  },
  mobileHeaderLeft: {
    flex: 1,
    minWidth: 0,
  },
  mobileBackButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    alignSelf: 'flex-start',
    paddingVertical: 4,
  },
  // Board pinned to the top on mobile/tablet, centered and padded so it never
  // touches the screen edges or overflows horizontally.
  mobileBoardWrap: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 2,
    paddingBottom: 8,
    paddingHorizontal: 8,
  },
  mobileBoardRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
  },
  // Full-width override for the game-details panel on mobile (it is a fixed
  // 324px left column on desktop).
  LeftcontainerMobile: {
    width: '100%',
    paddingHorizontal: 12,
  },
  mobilePageScroll: {
    flex: 1,
    backgroundColor: '#FAF6EB',
  },
  mobilePageContent: {
    width: '100%',
    alignItems: 'stretch',
    paddingBottom: 24,
  },
  mobileDetailsSection: {
    width: '100%',
    paddingHorizontal: 12,
    paddingBottom: 10,
  },
  mobileBottomReviewPanel: {
    width: '100%',
    marginTop: 0,
    backgroundColor: '#FFFFFF',
    borderTopLeftRadius: 17,
    borderTopRightRadius: 17,
    overflow: 'hidden',
    shadowColor: 'rgba(0,0,0, .4)',
    shadowOffset: {height: 1, width: 1},
    shadowOpacity: 1,
    shadowRadius: 1,
    elevation: 2,
  },
  container: {
    flexDirection: 'row',
    width: '100%',
    height: '100%',
    gap: 16,
    padding: 16,
    backgroundColor: '#FAF6EB',
  },
  NotesBox: {
    backgroundColor: CCColors.Primary.lightYellow,
    borderRadius: 5,
    padding: 10,
  },
  manualMovesContainer: {
    backgroundColor: CCColors.White,
    borderRadius: 5,
    marginBottom: 20,
    width: '70%',
    padding: 10,
  },
  selectedManualMove: {
    color: CCColors?.Primary?.Default,
    borderBottomWidth: 1,
    borderBottomColor: CCColors?.Primary?.Default,
  },
  Leftcontainer: {
    width: REVIEW_LEFT_PANEL_WIDTH,
    flexGrow: 0,
    flexShrink: 0,
    paddingRight: 2,
    overflowY: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
  },
  backButton: {
    gap: 5,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: CCColors?.Primary?.Brown,
    borderRadius: 8,
    padding: 8,
  },
  reviewBackButton: {
    alignSelf: 'flex-start',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 7,
    paddingVertical: 2,
    marginBottom: 12,
  },
  reviewBackText: {
    color: '#73695F',
    fontSize: 13,
    fontWeight: '700',
  },
  resultCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    padding: 12,
    marginBottom: 10,
    shadowColor: '#4D3F37',
    shadowOpacity: 0.07,
    shadowRadius: 10,
    shadowOffset: {width: 0, height: 4},
    borderWidth: 1,
    borderColor: 'rgba(77, 63, 55, 0.05)',
  },
  resultTopRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginBottom: 8,
  },
  resultTitleGroup: {
    flex: 1,
    minWidth: 0,
  },
  resultScorePill: {
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 8,
    backgroundColor: '#E4F6EB',
  },
  resultScorePillLost: {
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 8,
    backgroundColor: '#f8dbdb',
  },
  resultScoreText: {
    color: '#1E7A3D',
    fontSize: 18,
    fontWeight: '500',
    lineHeight: 20,
  },
  resultTitle: {
    color: '#262322',
    fontSize: 13,
    fontWeight: '800',
    lineHeight: 17,
  },
  resultTitleLost: {
    color: '#B00000',
  },
  resultReason: {
    color: '#8F7A65',
    fontSize: 12,
    lineHeight: 16,
  },
  openingName: {
    color: '#2F8E83',
    fontSize: 11,
    fontWeight: '700',
    marginLeft: 'auto',
    maxWidth: '48%',
    textAlign: 'right',
  },
  metaPillRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 6,
  },
  metaPill: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 7,
    backgroundColor: '#FAF6EB',
  },
  metaPillText: {
    color: '#4D3F37',
    fontSize: 11,
    fontWeight: '700',
  },
  reviewPlayerCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 16,
    marginBottom: 14,
    borderWidth: 1,
    borderColor: 'rgba(77, 63, 55, 0.08)',
    shadowColor: '#4D3F37',
    shadowOpacity: 0.08,
    shadowRadius: 12,
    shadowOffset: {width: 0, height: 6},
  },
  reviewPlayerCardDark: {
    backgroundColor: '#4D3F37',
    borderColor: '#4D3F37',
    shadowOpacity: 0.14,
  },
  playerHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 11,
    marginBottom: 13,
  },
  playerAvatar: {
    width: 38,
    height: 38,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F4EEE0',
  },
  playerAvatarDark: {
    backgroundColor: '#FACF47',
  },
  playerAvatarText: {
    color: '#4D3F37',
    fontSize: 15,
    fontWeight: '900',
  },
  playerInfo: {
    flex: 1,
    minWidth: 0,
  },
  playerName: {
    color: '#262322',
    fontSize: 14,
    fontWeight: '900',
  },
  playerNameDark: {
    color: '#FFFFFF',
  },
  playerNameLink: {
    color: '#3DAB9E',
    textDecorationLine: 'underline',
  },
  playerRating: {
    color: '#8F7A65',
    fontSize: 11,
    marginTop: 2,
  },
  playerRatingDark: {
    color: 'rgba(255,255,255,0.62)',
  },
  youBadge: {
    marginLeft: 6,
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 5,
    backgroundColor: '#FACF47',
  },
  youBadgeText: {
    color: '#4D3F37',
    fontSize: 9,
    fontWeight: '900',
  },
  accuracyValue: {
    color: '#6B584D',
    fontSize: 26,
    fontWeight: '500',
    lineHeight: 28,
    textAlign: 'right',
  },
  accuracyValueDark: {
    color: '#FACF47',
  },
  accuracyLabel: {
    color: '#A8A7A6',
    fontSize: 9,
    fontWeight: '800',
    letterSpacing: 0.6,
    textAlign: 'right',
    textTransform: 'uppercase',
  },
  statPillRow: {
    flexDirection: 'row',
    gap: 7,
  },
  statPill: {
    flex: 1,
    minHeight: 34,
    borderRadius: 9,
    padding: 7,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    gap: 5,
  },
  statPillDark: {
    backgroundColor: 'rgba(255,255,255,0.08)',
  },
  statNumber: {
    fontSize: 18,
    fontWeight: '500',
    lineHeight: 20,
  },
  statLabel: {
    fontSize: 11,
    fontWeight: '700',
  },
  principleSection: {
    marginTop: 11,
    paddingTop: 11,
    borderTopWidth: 1,
    borderTopColor: 'rgba(77,63,55,0.10)',
  },
  principleSectionDark: {
    borderTopColor: 'rgba(255,255,255,0.12)',
  },
  principleTitle: {
    color: '#A8A7A6',
    fontSize: 9,
    fontWeight: '900',
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    marginBottom: 7,
  },
  principleTitleDark: {
    color: 'rgba(255,255,255,0.5)',
  },
  principlePill: {
    flex: 1,
    minHeight: 34,
    borderRadius: 9,
    paddingHorizontal: 9,
    paddingVertical: 7,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 7,
  },
  principleIcon: {
    width: 18,
    height: 18,
    borderRadius: 9,
    alignItems: 'center',
    justifyContent: 'center',
  },
  principleIconText: {
    color: '#FFFFFF',
    fontSize: 11,
    fontWeight: '900',
    lineHeight: 14,
  },
  principlePillText: {
    fontSize: 12,
    fontWeight: '800',
  },
  insightsCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 16,
    marginBottom: 14,
    borderWidth: 1,
    borderColor: 'rgba(77, 63, 55, 0.08)',
    shadowColor: '#4D3F37',
    shadowOpacity: 0.08,
    shadowRadius: 12,
    shadowOffset: {width: 0, height: 6},
  },
  timelineCard: {
    width: '100%',
    marginBottom: 14,
  },
  insightsTitle: {
    color: '#73695F',
    fontSize: 11,
    fontWeight: '900',
    letterSpacing: 0.7,
    textTransform: 'uppercase',
    marginBottom: 12,
  },
  insightGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 9,
  },
  insightTile: {
    width: '48%',
    borderRadius: 11,
    backgroundColor: '#FAF6EB',
    paddingHorizontal: 12,
    paddingVertical: 11,
  },
  insightValue: {
    color: '#262322',
    fontSize: 24,
    fontWeight: '500',
    lineHeight: 26,
  },
  insightLabel: {
    color: '#73695F',
    fontSize: 11,
    marginTop: 3,
  },
  analysisHeaderRow: {
    minHeight: 40,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 10,
    gap: 10,
  },
  gameCategoryTitle: {},
  gameCategorySubTitle: {},
  downloadButton: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
    alignItems: 'center',
  },
  downloadButtonText: {
    marginLeft: 6,
    fontSize: 14,
  },
  analysisModeToggle: {
    alignSelf: 'flex-start',
    flexDirection: 'row',
    alignItems: 'center',
    borderColor: CCColors.Primary.Brown,
    borderRadius: 8,
    borderWidth: StyleSheet.hairlineWidth,
    marginBottom: vs(12),
    overflow: 'hidden',
  },
  analysisModeToggleHeader: {
    alignSelf: 'center',
    marginBottom: 0,
    marginLeft: 'auto',
    marginRight: 10,
  },
  analysisModeToggleMobile: {
    alignSelf: 'flex-end',
    marginLeft: 0,
    marginRight: 0,
  },
  analysisModeOption: {
    minWidth: 86,
    minHeight: 34,
    paddingHorizontal: 12,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    backgroundColor: CCColors.White,
  },
  analysisModeOptionSelected: {
    backgroundColor: CCColors.Primary.Brown,
  },
  analysisModeOptionDisabled: {
    opacity: 0.6,
  },
  winningBar: {
    // width: '50%',
    width: 25,
    // margin: 'auto',
    justifyContent: 'center',
  },
  winningBarMobile: {
    // width: '50%',
    width: 'auto',
  },
  chessboard: {
    flex: 1,
    minWidth: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  eachPlayerName: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  eachPlayerDetails: {
    marginBottom: vs(18),
  },
  BrownBox: {
    width: 15,
    height: 15,
    backgroundColor: CCColors.Primary.Brown,
    borderColor: CCColors.Primary.Brown,
    borderWidth: StyleSheet.hairlineWidth,
    borderRadius: 2,
  },
  whiteBox: {
    width: 15,
    height: 15,
    backgroundColor: CCColors.White,
    borderColor: CCColors.Black,
    borderWidth: StyleSheet.hairlineWidth,
    borderRadius: 2,
  },
  movesList: {
    width: REVIEW_RIGHT_PANEL_WIDTH,
    flexGrow: 0,
    flexShrink: 0,
    minWidth: 0,
    backgroundColor: '#FAF6EB',
  },
  boardColumn: {
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    overflow: 'hidden',
  },
  boardColumnContent: {
    flex: 1,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 12,
    paddingTop: 10,
    paddingBottom: 18,
  },
  boardWithEval: {
    flexDirection: 'row',
    alignItems: 'stretch',
    gap: 10,
  },
  boardSurface: {
    flexGrow: 0,
    flexShrink: 0,
    minWidth: 0,
    borderRadius: 10,
    overflow: 'hidden',
  },
  puzzleFeedbackSlot: {
    minHeight: 0,
    alignSelf: 'center',
  },
  puzzleFeedback: {
    width: '100%',
    minHeight: 40,
    borderRadius: 8,
    overflow: 'hidden',
  },
  puzzleFeedbackText: {
    flex: 1,
    fontWeight: '500',
  },
  centerWinningBar: {
    width: 18,
    borderRadius: 7,
    overflow: 'hidden',
    backgroundColor: '#6B584D',
  },
  boardNav: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    paddingHorizontal: 10,
    paddingVertical: 8,
    borderRadius: 13,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: 'rgba(77, 63, 55, 0.08)',
    shadowColor: '#4D3F37',
    shadowOpacity: 0.08,
    shadowRadius: 12,
    shadowOffset: {width: 0, height: 6},
  },
  mobileBoardNav: {
    width: '94%',
    maxWidth: 460,
    marginTop: 8,
    marginBottom: 2,
    paddingHorizontal: 8,
    paddingVertical: 7,
    gap: 8,
    alignSelf: 'center',
  },
  mobileBoardNavButton: {
    width: 36,
    height: 36,
  },
  boardNavButton: {
    width: 38,
    height: 38,
    borderRadius: 9,
    backgroundColor: '#FAF6EB',
    alignItems: 'center',
    justifyContent: 'center',
  },
  boardMoveLabel: {
    minWidth: 150,
    textAlign: 'center',
    color: '#262322',
    fontSize: 14,
    fontWeight: '900',
  },
  mobileBoardMoveLabel: {
    flex: 1,
    minWidth: 0,
    fontSize: 13,
  },
  timelineWrap: {
    width: REVIEW_CENTER_WIDTH,
  },
  timelineHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 7,
  },
  timelineTitle: {
    color: '#73695F',
    fontSize: 11,
    fontWeight: '900',
    letterSpacing: 0.7,
    textTransform: 'uppercase',
  },
  timelineEvalPill: {
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 7,
    borderWidth: 1,
    borderColor: 'rgba(77,63,55,0.10)',
    color: '#73695F',
    fontSize: 11,
    fontWeight: '700',
  },
  timelineGraph: {
    height: 108,
    borderRadius: 12,
    overflow: 'hidden',
    backgroundColor: '#E7DCC8',
    borderWidth: 1,
    borderColor: 'rgba(77,63,55,0.16)',
    cursor: 'pointer',
  },
  timelineBase: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    height: '52%',
    backgroundColor: '#E7DCC8',
    opacity: 0.86,
  },
  timelineLine: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: '42%',
    height: 3,
    backgroundColor: '#E8732F',
  },
  timelineDot: {
    position: 'absolute',
    width: 10,
    height: 10,
    borderRadius: 5,
    borderWidth: 2,
    borderColor: '#FFFFFF',
  },
  timelineCurrentLine: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: 2,
    backgroundColor: '#FF7A33',
  },
  timelineCurrentKnob: {
    position: 'absolute',
    top: -4,
    left: -5,
    width: 12,
    height: 12,
    borderRadius: 6,
    backgroundColor: '#FF7A33',
    borderWidth: 2,
    borderColor: '#FFFFFF',
  },
  timelineLegend: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 14,
    marginTop: 9,
  },
  legendItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
  },
  legendDot: {
    width: 9,
    height: 9,
    borderRadius: 5,
  },
  legendText: {
    color: '#73695F',
    fontSize: 11,
  },
  currentLegendItem: {
    marginLeft: 'auto',
    flexShrink: 0,
  },
  currentLegendLine: {
    width: 14,
    height: 2,
    borderRadius: 1,
    backgroundColor: '#FF7A33',
  },
  movesListMobile: {
    flex: 1,
  },
  move: {
    padding: 5,
  },
  currentMove: {
    backgroundColor: '#e0e0e0',
  },

  blunder: {
    color: 'red',
  },

  mistake: {
    color: 'orange',
  },

  inaccuracy: {
    color: '#c3c34e',
  },

  playerDetails: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    // marginVertical: vs(15),
  },

  profilePic: {
    width: vs(40),
    height: vs(40),
    borderRadius: 20,
    backgroundColor: CCColors?.Grey?.Grey,
    marginRight: vs(15),
  },
  name: {},
  rating: {},
  chessboardTable: {
    // width: '100%',
    // flex: 1,
    // flexBasis: '100%',
    // overflow: 'hidden',
    flexDirection: 'row',
  },
  chessboardTableMobile: {
    flexDirection: 'column-reverse',
  },
});

export default styles;
